export default __webpack_public_path__ + "static/media/plan-a-media-group-plan-a-live-1.4182c845.png";